import { render, staticRenderFns } from "./SchooladminAccounts.vue?vue&type=template&id=1cede1f6&"
import script from "./SchooladminAccounts.vue?vue&type=script&lang=js&"
export * from "./SchooladminAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SchooladminAccounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports